import type { StaticImageData } from "next/image";
import Image from "next/image";

import { H1 } from "../atoms/typography/H1";

export const Offline = ({ bg }: { bg: StaticImageData }) => {
  return (
    <div className="container mx-auto h-[80vh] p-4">
      <div className="flex h-full flex-row items-center justify-center">
        <div className="mr-6 hidden max-w-xs md:block">
          <Image src={bg} width={559} height={826} alt="" placeholder="blur" />
        </div>

        <div className="max-w-md">
          <H1>Offline</H1>
          <div>We're in maintenance mode and will be back online soon</div>
        </div>
      </div>
    </div>
  );
};
